import  { AbilityBuilder, Ability } from "@casl/ability";

// export default AbilityBuilder.define(can => {
//     can('test', 'test');
// });

export default function defineAbilitiesFor(permissions) {
    const { rules, can } = AbilityBuilder.extract();

    if(permissions != undefined){
      permissions.forEach(permission => {
        can(permission.group, permission.name);
      });
    }

    // can('User', 'user-delete')
    // can('test', 'test');
    // can('update', 'User', { id: user.id });
    //
    // if (user.role === 'doctor') {
    //     can('manage', 'Patient', { treatedBy: user.id })
    // }

    return new Ability(rules)
}
